module.exports = "/assets/data/9418602256df5fe7f78fc0df0c2b0eda-BR1.data.json";